<template >
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="onCancel" @confirm="onConfirm">
    <el-form class="ghost-button-styles" ref="pageFormRef" :model="pageForm" label-width="110px">
      <el-form-item>
        <TagGroup v-model="activeTag" :pageGroup="pageGroup" @remove="onRemoveTag" @add="onAddTag">
          <!-- 微信小游戏不需要新增组合 ，使用空元素覆盖掉组件内的btn-->
          <template #btn v-if="isMiniGame">
            <span>&ensp;</span>
          </template>
        </TagGroup>
      </el-form-item>

      <div v-for="(g, index) in pageGroup" :key="index" v-show="activeTag === index">
        <el-form-item label="落地页跳转类型">
          <el-radio-group v-model="g.pageType" @change="onPageTypeChange">
            <el-radio-button ghost :label="4" v-if="isMiniGame"> 微信小游戏 </el-radio-button>
            <template v-else>
              <!-- ios 平台才显示 -->
              <el-radio-button ghost :label="3" v-if="isIOS"> APP STORE </el-radio-button>
              <el-radio-button ghost :label="5"> 官方落地页 </el-radio-button>
              <el-radio-button ghost :label="2"> 蹊径性能版 </el-radio-button>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="page" :rules="{ required: true, validator: formValidator }">
          <el-select v-if="[2].includes(g.pageType)" v-model="g.page" value-key="page_id" @change="onLandingPageChange">
            <el-option v-for="item in xijingPages" :key="item.page_id" :label="item.page_name" :value="item"> </el-option>
          </el-select>

          <el-select v-if="[5].includes(g.pageType)" v-model="g.page" value-key="page_id" @change="onLandingPageChange">
            <el-option v-for="item in officialPages" :key="item.page_id" :label="item.page_name" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </Modal>
</template>
<script>
import { getXijingPages, getGdtOfficialPages } from '@/api/tencent.model'
import { PLATFORM } from '@/views/create/gdt/model/project-const.js'
import TagGroup from './pages-v3/tag-group.vue'

import Modal from './modal.vue'

export default {
  components: { Modal, TagGroup },
  props: {
    currentRow: Object
  },
  data() {
    return {
      activeTag: 0,
      pageGroup: [],
      rules: {},
      loading: false,
      allPages: [],
      xijingPages: [],
      officialPages: []
    }
  },
  computed: {
    pageForm: {
      get() {
        return this.pageGroup[this.activeTag]
      },
      set(form) {
        this.pageGroup[this.activeTag] = form
      }
    },
    rawForm() {
      return this.currentRow || {}
    },

    isIOS() {
      return this.rawForm.plan?.ch_platform_id === PLATFORM.IOS
    },
    isAndroid() {
      return this.rawForm.plan?.ch_platform_id === PLATFORM.ANDROID
    },
    isMiniGame() {
      return this.rawForm.plan?.ch_platform_id === PLATFORM.MINIGAME
    }
  },
  methods: {
    getForm() {
      let pageType = 0
      if (this.isIOS) pageType = 3
      if (this.isAndroid) pageType = 2
      if (this.isMiniGame) pageType = 4
      return {
        pageType,
        page: {}
      }
    },
    formValidator(rule, value, callback) {
      for (let i = 0; i < this.pageGroup.length; i++) {
        const { page, pageType } = this.pageGroup[i]

        // 应用商店不校验
        if (pageType === 3) continue
        // 小游戏不校验
        if (pageType === 4) continue

        if (!page || !page.page_id) {
          this.activeTag = i
          callback(new Error('请选择落地页'))
          break
        }
      }

      callback()
    },
    onModalOpen() {
      this.getPages()
      this.activeTag = 0
      let { pageInfo } = this.rawForm?.creative || {}
      const { landingPages } = this.currentRow
      if (landingPages?.info) {
        pageInfo = landingPages.info
      }

      if (!pageInfo || pageInfo?.length === 0) {
        this.pageGroup.push(this.getForm())
      } else {
        this.pageGroup = pageInfo
      }

      this.$nextTick(() => {
        this.$refs.pageFormRef?.clearValidate()
      })
    },
    onConfirm() {
      this.$refs.pageFormRef.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.pageGroup)
          this.pageGroup = []
        }
      })
    },
    onCancel() {
      this.$emit('cancel')
      this.pageGroup = [this.getForm()]
      this.$refs.pageFormRef.clearValidate()
    },

    onRemoveTag(index) {
      this.pageGroup.splice(index, 1)
      if (this.pageGroup.length > index) {
        this.activeTag = index
      } else {
        this.activeTag = this.pageGroup.length - 1
      }
      this.$refs.pageFormRef.clearValidate()
    },
    onAddTag() {
      this.pageGroup.push(this.getForm())
      this.activeTag = this.pageGroup.length - 1
    },
    onPageTypeChange() {
      this.$set(this.pageGroup, this.activeTag, {
        ...this.pageForm,
        page: {}
      })
      this.$refs.pageFormRef.clearValidate()
    },
    onLandingPageChange() {
      this.$refs.pageFormRef.clearValidate()
    },
    getPages() {
      const { account, promotedObject } = this.rawForm.plan
      const { promoted_object_type, promoted_object_id } = promotedObject
      const params = {
        ad_account_id: account.id,
        promoted_object_type,
        promoted_object_id
      }
      const pageRequests = [getXijingPages(params), getGdtOfficialPages(params)]
      this.loading = true

      Promise.all(pageRequests)
        .then((data) => {
          const [xijingPages, officialPages] = data
          this.xijingPages = xijingPages
          this.officialPages = officialPages
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .group-tags {
  .el-tag {
    margin-right: 10px;
  }
}
</style>
